import { UntitledIcon } from '@faceup/icons'
import { ulArrowLeft } from '@faceup/icons/ulArrowLeft'
import { ulXClose } from '@faceup/icons/ulXClose'
import { Modal as AntModal } from 'antd'
import type { MouseEvent, ReactNode } from 'react'
import { Button } from './Button'
import { Typography } from './Typography'

export type ModalProps = {
  children?: ReactNode
  open: boolean
  onClose?: (e: MouseEvent<HTMLButtonElement>) => void
  afterClose?: () => void
  width?: number | string
  footer?: ReactNode
  loading?: boolean
  maskClosable?: boolean
  'data-test'?: string
  'data-onboarding'?: string
} & ModalTitleProps

type ModalTitleProps = {
  title?: ReactNode
  onClickBackArrow?: () => void
  icon?: ReactNode
}

export const Modal = ({
  children,
  open,
  onClose,
  width,
  title,
  icon,
  footer,
  loading,
  onClickBackArrow,
  maskClosable,
  'data-test': dataTest,
  'data-onboarding': dataOnboarding,
  ...props
}: ModalProps) => {
  return (
    <AntModal
      title={title && <ModalTitle title={title} onClickBackArrow={onClickBackArrow} icon={icon} />}
      open={open}
      onCancel={onClose}
      footer={footer ?? null}
      centered
      width={width}
      loading={loading}
      bodyProps={{ 'data-test': dataTest, 'data-onboarding': dataOnboarding }}
      closeIcon={onClose ? <UntitledIcon icon={ulXClose} color='#547599' size={24} /> : null}
      maskClosable={maskClosable ?? undefined}
      {...props}
    >
      {children}
    </AntModal>
  )
}

const ModalTitle = ({ title, onClickBackArrow, icon }: ModalTitleProps) => {
  return (
    <div className='ant-modal-title-wrapper'>
      {onClickBackArrow && (
        <Button
          size='small'
          type='text'
          onClick={onClickBackArrow}
          icon={<UntitledIcon icon={ulArrowLeft} size={20} rtlFlip />}
          label=''
        />
      )}
      {icon && <div className='ant-modal-title-icon'>{icon}</div>}
      <Typography.Title level={5} color='text' ellipsis>
        {title}
      </Typography.Title>
    </div>
  )
}
